import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_SUBSCRIPTION_INTEREST_REGISTRATIONS_API_ID =
  'DASHBOARD/FETCH_SUBSCRIPTION_INTEREST_REGISTRATIONS_API_ID';

const apiCall = createApiCall(
  FETCH_SUBSCRIPTION_INTEREST_REGISTRATIONS_API_ID,
  ({ id, ...params }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/subscriptions/${id}/interest-registrations`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
